import React from 'react';
import policy1 from '../../images/policy1.png'
import policy2 from '../../images/policy2.png'
import policy3 from '../../images/policy3.png'

const PolicySection = (props) => {

    return (
        <section className="section_space policy_section">
            <div className="container">
                <div className="row">
                       <div className='col-md-12 text-center'>
                        <h2>Why Ease My Hotel</h2>
                       </div>
                        <div className="col-lg-4">
                            <div className='text-center policy_section_item'>
                                <img src={policy1} />
                                <h4>Replacing multiple software </h4>
                                <br/>
                                <h4>Saving Cost</h4>
                                <p className='desp_div'>From bookings to billing, unify your hotel operations under one roof.</p>
                           </div>
                        </div>

                        <div className="col-lg-4">
                            <div className='text-center policy_section_item'>
                                <img src={policy2} />
                                <h4>More control for hotel owners</h4>
                                <br/>
                                <h4>More Control</h4>
                                <p className='desp_div'>Stay in control of every aspect of your property, anytime, anywhere.</p>
                           </div>
                        </div>

                        <div className="col-lg-4">
                            <div className='text-center policy_section_item'>
                                <img src={policy3} />
                                <h4>Better customer experience at hotel</h4>
                                <br/>
                                <h4>Saving time</h4>
                                <p className='desp_div'>Deliver seamless check-ins, spotless rooms, and faster service with ease.</p>
                           </div>
                        </div>
                </div>
            </div>
        </section>
    );
}

export default PolicySection;